import { createSlice } from "@reduxjs/toolkit";
import config from "../../config";
import axios from "axios";

const ProductSlice = createSlice({
  name: "Product",

  initialState: {
    productCategory: [],
    bestProduct: [],
    trendingProduct: [],

    categoryLoading: false,
    categoryError: false,

    bestProductLoading: false,
    bestProductError: false,

    trendingProductLoading: false,
    trendingProductError: false,
  },

  reducers: {
    fetchCategoryStart: (state) => {
      state.categoryLoading = true;
      state.categoryError = false;
    },
    fetchCategorySuccess: (state, action) => {
      state.categoryLoading = false;
      state.productCategory = action.payload;
    },
    fetchCategoryFailure: (state, action) => {
      state.categoryLoading = false;
      state.categoryError = action.payload;
    },

    fetchtrendingProductStart: (state) => {
      state.trendingProductLoading = true;
      state.trendingProductError = false;
    },
    fetchtrendingProductSuccess: (state, action) => {
      state.trendingProductLoading = false;
      state.trendingProduct = action.payload;
    },
    fetchtrendingProductFailure: (state, action) => {
      state.trendingProductLoading = false;
      state.trendingProductError = action.payload;
    },

    fetchBestProductStart: (state) => {
      state.bestProductLoading = true;
      state.bestProductError = false;
    },
    fetchBestProductSuccess: (state, action) => {
      state.bestProductLoading = false;
      state.bestProduct = action.payload;
    },
    fetchBestProductFailure: (state, action) => {
      state.bestProductLoading = false;
      state.bestProductError = action.payload;
    },
  },
});

export const {
  fetchCategoryStart,
  fetchCategorySuccess,
  fetchCategoryFailure,
  fetchtrendingProductStart,
  fetchtrendingProductSuccess,
  fetchtrendingProductFailure,
  fetchBestProductStart,
  fetchBestProductSuccess,
  fetchBestProductFailure,
} = ProductSlice.actions;

export const fetchProduct = () => async (dispatch, getState) => {
  const { Product } = getState();
  if (
    Product.productCategory.length > 0 ||
    Product.bestProduct.length > 0 ||
    Product.trendingProduct.length > 0
  ) {
    return;
  }
  dispatch(fetchCategoryStart());
  dispatch(fetchtrendingProductStart());
  dispatch(fetchBestProductStart());

  try {
    const response = await axios.get(`${config.apiUrl}/category-list`);
    dispatch(fetchCategorySuccess(response.data.list));
    dispatch(fetchtrendingProductSuccess(response.data.trending_products));
    dispatch(fetchBestProductSuccess(response.data.best_selling));
  } catch (error) {
    dispatch(fetchCategoryFailure(error));
    dispatch(fetchtrendingProductFailure(error));
    dispatch(fetchBestProductFailure(error));
  }
};

export default ProductSlice.reducer;
